import Controller from './application_controller'

/**
 * Tracks Turbo link navigations and the request state.
 */
export default class extends Controller {
  navigationEvent = null
  navigationTarget = null

  connect() {
    this.addEventListener('turbo:click', event => this.recordNavigation(event))
    this.addEventListener('turbo:before-fetch-request', event => this.markBusyIfNavigationRequest(event))
    this.addEventListener('turbo:before-fetch-response', event => this.clearNavigationAfterResponse(event))
    this.addEventListener('turbo:fetch-request-error', event => this.clearNavigationAfterResponse(event))
    this.addEventListener('turbo:before-cache', event => this.clearNavigation())
  }

  disconnect() {
    console.warn("Clearing from disconnect")
    this.clearNavigation()
    super.disconnect()
  }

  recordNavigation(event) {
    this.navigationEvent = event
  }

  markBusyIfNavigationRequest(event) {
    if (this.isPrefetchRequest(event)) {
      return
    }

    if (event.detail.url == this.navigationEvent?.detail.url) {
      this.markNavigationAsBusy(event.target)
    } else {
      this.clearNavigation()
    }
  }

  async clearNavigationAfterResponse(event) {
    if (this.isPrefetchRequest(event) || this.navigationTarget !== event.target) {
      return
    }

    // Errors won't have a fetchResponse
    if (event.detail.fetchResponse) {
      await event.detail.fetchResponse.responseHTML
    }

    this.clearNavigation()
  }

  markNavigationAsBusy(target) {
    this.navigationTarget = target
    this.navigationEvent?.target?.setAttribute('aria-busy', 'true');
  }

  clearNavigation() {
    this.navigationEvent?.target?.removeAttribute('aria-busy');
    delete this.navigationEvent
    delete this.navigationTarget
  }

  isPrefetchRequest(event) {
    return !event.target.matches('html, turbo-frame, form')
  }
}
